import React from "react";
import { Row } from "react-bootstrap";
import { FaWrench, FaBolt, FaBroom, FaShieldAlt } from "react-icons/fa";

const Revenue = () => {
  return (
    <section className="services py-5 bg-white">
      <div className="container py-5">
        {/* Heading */}
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center mb-5">
            <span className="works-subtitle">Monetization</span>
            <h2 className="display-5 fw-bold mb-4">
              Revenue Model: How We Earn
            </h2>
            <p className="lead">
              Multiple income streams built on services, partnerships, and
              commissions.
            </p>
          </div>
        </div>

        {/* Categories */}
        <Row className="g-4">
          {[
            {
              icon: <FaWrench />,
              title: "Primary Income ",
              subtitle: "Commission per service booking 10-15% ",
            },
            {
              icon: <FaBolt />,
              title: "Product Sales Commission ",
              subtitle: "B2B partnerships ",
            },
            {
              icon: <FaBroom />,
              title: "Paid Promotions ",
              subtitle: "Workers/Sellers featured listings ",
            },
            {
              icon: <FaShieldAlt />,
              title: "Additional Revenue ",
              subtitle: "Platform Advertisement, Rider Booking Commissions",
            },
          ].map((item, index) => (
            <div key={index} className="col-md-6 col-lg-3">
              <div className="card h-100 text-center hover-card">
                <div className="card-body">
                  <div className={`icon-wrapper text-white`}>{item.icon}</div>
                  <h5 className="mb-0">{item.title}</h5>
                  <p className="mb-0">{item.subtitle}</p>
                </div>
              </div>
            </div>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default Revenue;
